<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" mode="over" [opened]="false">
    <div class="drawer-header">
      <div class="drawer-heading">
        <span class="drawer-title">{{'reservemain.title'|traduccion}}</span>
        <span class="drawer-subtitle">{{'nav.reserve'|traduccion}}</span>
      </div>
      <div class="drawer-header-actions">
        <button type="button" class="drawer-language" [matMenuTriggerFor]="langMenu" [attr.aria-label]="'nav.switchLanguage'|traduccion">
          <img src="/assets/webp/{{langSel.name}}.webp" width="24" alt="" />
          <mat-icon>expand_more</mat-icon>
        </button>
        <button type="button" class="drawer-close" (click)="drawer.close()" [attr.aria-label]="'nav.closeMenu'|traduccion">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="drawer-body">
      <div class="drawer-account">
        <a *appShowForSigned="'not'" class="drawer-account-link" [routerLink]="language.path('signin')" (click)="drawer.close()">
          <span class="drawer-avatar"><mat-icon>person</mat-icon></span>
          <span class="drawer-account-text">{{'signin'|traduccion}}</span>
          <mat-icon class="drawer-chevron">chevron_right</mat-icon>
        </a>
        <button *appShowForSigned type="button" class="drawer-account-link" [matMenuTriggerFor]="profileMenu">
          <span class="drawer-avatar"><mat-icon>person</mat-icon></span>
          <span class="drawer-account-text">{{'reserves.profile'|traduccion}}</span>
          <mat-icon class="drawer-chevron">chevron_right</mat-icon>
        </button>
        <mat-menu #profileMenu="matMenu">
          <button mat-menu-item [routerLink]="language.path('reserves')" (click)="drawer.close()">
            <mat-icon>confirmation_number</mat-icon>
            {{'reserves.myReserves'|traduccion}}
          </button>
          <button *appShowForRoles="['ROLE_ADMIN']" mat-menu-item [routerLink]="language.path('my-wallet')" (click)="drawer.close()">
            <mat-icon>wallet</mat-icon>
            {{'reserves.myWallet'|traduccion}}
          </button>
          <button *appShowForRoles="['ROLE_COMMISSION_AGENT']" mat-menu-item [routerLink]="language.path('my-commissions')" (click)="drawer.close()">
            <mat-icon>payments</mat-icon>
            {{'reserves.myCommissions'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="language.path('change-password')" (click)="drawer.close()">
            <mat-icon>lock</mat-icon>
            {{'change_password'|traduccion}}
          </button>
          <button mat-menu-item (click)="logout();drawer.close();">
            <mat-icon>logout</mat-icon>
            {{'logout'|traduccion}}
          </button>
        </mat-menu>
      </div>

      <nav class="drawer-links" [attr.aria-label]="'nav.mainNavigation'|traduccion">
        @if (landingEnabled) {
          <a class="drawer-link" [href]="language.path() + '#como-funciona'" (click)="drawer.close()"><mat-icon>help_outline</mat-icon><span>{{'nav.howItWorks'|traduccion}}</span><mat-icon class="drawer-chevron">chevron_right</mat-icon></a>
          <a class="drawer-link" [href]="language.path() + '#tamanos'" (click)="drawer.close()"><mat-icon>straighten</mat-icon><span>{{'nav.sizes'|traduccion}}</span><mat-icon class="drawer-chevron">chevron_right</mat-icon></a>
          @if (configService.settings.visibilityControl?.faqEnabled) {
            <a class="drawer-link" [href]="language.path() + '#faq'" (click)="drawer.close()"><mat-icon>quiz</mat-icon><span>{{'nav.faq'|traduccion}}</span><mat-icon class="drawer-chevron">chevron_right</mat-icon></a>
          }
          <a class="drawer-link" [href]="language.path() + '#contacto'" (click)="drawer.close()"><mat-icon>mail_outline</mat-icon><span>{{'nav.contact'|traduccion}}</span><mat-icon class="drawer-chevron">chevron_right</mat-icon></a>
        }
      </nav>
    </div>
  </mat-sidenav>


  <mat-sidenav-content>
    <mat-toolbar color="primary" class="toolbar">
      <button type="button" mat-icon-button (click)="drawer.toggle()" class="menu-button">
        <mat-icon>menu</mat-icon>
      </button>

      <a class="navbar-brand" [routerLink]="homePath">
        <img height="50px" alt="{{configService.settings.name}}" [src]="configService.settings.logo.imageMedium" [srcset]="
                    configService.settings.logo.imageSmall + ' 200w,
                ' + configService.settings.logo.imageMedium + ' 400w,
                ' + configService.settings.logo.imageLarge + ' 800w'
            " />
      </a>
      <span class="brand-divider" aria-hidden="true"></span>

      <a class="reserve-button" [routerLink]="language.path('locker-location')">{{'nav.reserve'|traduccion}}</a>

      <nav class="nav-links" [attr.aria-label]="'nav.mainNavigation'|traduccion">
        @if (landingEnabled) {
          <a class="section-link" [href]="language.path() + '#como-funciona'">{{'nav.howItWorks'|traduccion}}</a>
          <a class="section-link" [href]="language.path() + '#tamanos'">{{'nav.sizes'|traduccion}}</a>
          @if (configService.settings.visibilityControl?.faqEnabled) {
            <a class="section-link" [href]="language.path() + '#faq'">{{'nav.faq'|traduccion}}</a>
          }
          <a class="section-link" [href]="language.path() + '#contacto'">{{'nav.contact'|traduccion}}</a>
        }
      </nav>

      

      <span class="spacer"></span>

      <div class="account-links">
        <button class="language-button" mat-button [matMenuTriggerFor]="langMenu" [attr.aria-label]="'nav.switchLanguage'|traduccion">
          <img src="/assets/webp/{{langSel.name}}.webp" width="24" alt="" />
          <!--<span>{{langSel.name}}</span>-->
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #langMenu="matMenu">
          @for (lang of langs; track lang) {
            <div>
              @if (lang.name!=langSel.name) {
                <button mat-menu-item (click)="selectLang(lang)">
                  <img src="/assets/webp/{{lang.name}}.webp" width="24" alt="" /> {{lang.name}}
                </button>
              }
            </div>
          }
        </mat-menu>

        <span class="account-divider" aria-hidden="true"></span>

        <a *appShowForSigned="'not'" class="profile-link" mat-button [routerLink]="language.path('signin')">
          <mat-icon>account_circle</mat-icon>
          {{'signin'|traduccion}}
        </a>
        <button *appShowForSigned class="profile-link" mat-button [matMenuTriggerFor]="accountMenu">
          <mat-icon>account_circle</mat-icon>
          {{'reserves.profile'|traduccion}}
          <mat-icon class="profile-chevron">expand_more</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu" panelClass="profile-menu">
          <button mat-menu-item [routerLink]="language.path('reserves')">
            <mat-icon>confirmation_number</mat-icon>
            {{'reserves.myReserves'|traduccion}}
          </button>
          <button *appShowForRoles="['ROLE_ADMIN']" mat-menu-item [routerLink]="language.path('my-wallet')">
            <mat-icon>wallet</mat-icon>
            {{'reserves.myWallet'|traduccion}}
          </button>
          <button *appShowForRoles="['ROLE_COMMISSION_AGENT']" mat-menu-item [routerLink]="language.path('my-commissions')">
            <mat-icon>payments</mat-icon>
            {{'reserves.myCommissions'|traduccion}}
          </button>
          <button mat-menu-item [routerLink]="language.path('change-password')">
            <mat-icon>lock</mat-icon>
            {{'change_password'|traduccion}}
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            {{'logout'|traduccion}}
          </button>
        </mat-menu>
      </div>

      
      </mat-toolbar>

    </mat-sidenav-content>
  </mat-sidenav-container>
